var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Folgen'),_c('Team'),_c('Kontakt'),_c('Partner'),_c('Sponsorenwand')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }